export type Props = {};

export type Commission = {
  id: number;
  name: string;
  type: string;
};

export enum COMMISSION_TYPES {
  STANDARD = 'STANDARD',
  ONGOING = 'ONGOING',
  ENHANCED = 'ENHANCED',
}
